/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Route, Switch, Redirect } from "react-router-dom";

// core components
import DemoNavbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { Alert } from "components/Varios/Alert.js";
import DatosGenerales from 'components/DatosGenerales';

import { history } from '../helpers/history';
import { Role } from '../helpers/role';
import { authenticationService } from '../services/authentication.service';
import { PrivateRoute } from '../components/Varios/PrivateRoute';

import routes from "routes.js";

//Barra de navegacion
import MetisMenu from 'react-metismenu';

//Dashboard de inicio
import Dashboard_Admin from "components/Admin/Inicio-Admin/Dashboard_Admin";
import Sidebar_Principal from "components/Sidebar/Sidebar_Principal";


//RUTAS DE OPCIONES ADMINISTRADOR
import ADMINISTRADOR_ROUTES from "../components/Admin/RutasAdministrador.tsx";
// Para efectos
import { Transition } from 'react-transition-group'
import { detectResize } from "./functionsLayout";

//Funciones
import { ObtenerFechaFromIsoFormat } from "functions/DatesFunctions";
import ModalActualizarDatosPers from "components/Varios/ModalActualizarDatosPers";
import SolicitudesCertificados from "components/Admin/Certificados/AnalistaAdministraSolicitudesCertificados";


import ModalTiempoSesion from "components/Varios/ModalTiempoSesion";



var ps;

class Dashboard extends React.Component {
    state = {
        currentUser: null,
        backgroundColor: "blue",
        openSideBar: true,
        showModalCambios: true,
        showModalSession: false
    };
    mainPanel = React.createRef();
    callBackStateResize = () => {
        this.setState({ openSideBar: true })
    }

    isSessionActive = () => {
        const tiempoExpiraSesion = new Date(authenticationService.currentUserValue.fechaHoraSesionActiva);
        const fechaActual = new Date(authenticationService.currentUserValue.fechaHoraSesionComparar);

        var fechaActualizado = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), fechaActual.getHours(), fechaActual.getMinutes(), fechaActual.getSeconds() + 2)
        if (document.visibilityState === 'hidden') {
            // Browser window is minimized or tab is switched
            fechaActualizado = new Date(fechaActual.getFullYear(),fechaActual.getMonth(),fechaActual.getDate(),fechaActual.getHours(),fechaActual.getMinutes(),fechaActual.getSeconds()+27)
        } 
        
        
        authenticationService.UpdateSessionCompareTime(fechaActualizado);

        if (tiempoExpiraSesion.getTime() > fechaActualizado.getTime()) {
            ;

        }
        else {

            this.setState({ showModalSession: true });
        }
        this.runFunction();
    };

    runFunction = () => {
        // Use setTimeout instead of setInterval
        // This ensures that the function is called after a delay
        // even if the browser window is minimized
        this.timeout = setTimeout(this.isSessionActive, 20000); // Example: 1 second delay
    }





    componentDidMount() {
        // if (navigator.platform.indexOf("Win") > -1) {
        //     ps = new PerfectScrollbar(this.mainPanel.current);
        //     document.body.classList.toggle("perfect-scrollbar-on");
        // }

        authenticationService.currentUser.subscribe(x => this.setState({
            currentUser: x
        }));
        window.addEventListener("resize", () => detectResize(this.callBackStateResize));
        //document.addEventListener("visibilitychange", this.handleVisibilityChange);

        
        //this.runFunction()
    }
    componentWillUnmount() {
        // if (navigator.platform.indexOf("Win") > -1) {
        //     ps.destroy();
        //     document.body.classList.toggle("perfect-scrollbar-on");
        // }
        window.removeEventListener('resize', this.callBackStateResize);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        clearTimeout(this.timeout);
    }
    componentDidUpdate(e) {
        if (e.history.action === "PUSH") {
            document.documentElement.scrollTop = 0;
            document.scrollingElement.scrollTop = 0;
            this.mainPanel.current.scrollTop = 0;
        }
    }
    handleColorClick = (color) => {
        this.setState({ backgroundColor: color });
    };
    contenido_sidebar_principal = [{
        icon: 'icon-class-name',
        label: 'Salud',
        to: '/admin/salud',
    },
    {
        icon: 'icon-class-name',
        label: 'Second Item',
        content: [
            {
                icon: 'icon-class-name',
                label: 'Sub Menu of Second Item',
                to: '#another-link',
            },
        ],
    },
    ]
    render() {
        const { currentUser } = this.state;

        return (
            <div>
                <DemoNavbar {...this.props} />
                <div className="row no-margin" align="left">
                    <div className="col-md-8 col-sm-12 col-xs-12" align="left" >
                    </div>
                    {currentUser && currentUser.ultimoCambioDatosPersonales ?
                        <div className="ultima-actualizacion col-md-4 col-sm-12 col-xs-12 pt-2" align="right" style={{ color: "#B2B2B2", verticalAlign: "middle" }}><em> &Uacute;ltima actualizaci&oacute;n: {ObtenerFechaFromIsoFormat(this.state.currentUser.ultimoCambioDatosPersonales)}</em>  </div>
                        : ''}
                </div>

                {currentUser !== null && currentUser.idpersona !== 0 &&
                    <div className="parent_supremo"  /*style={{ overflowY: "scroll", height: "100vh", overflow: "visible", overflowAnchor: "none" }}*/>
                        {/* <div className="contenedor_sidebar_principal">
                        <div className="sidebar_principal" ref="sidebar">
                            <MetisMenu content = {this.contenido_sidebar_principal}/>
                        </div>
                        <div className="contenedor_texto_actualizacion">
                            {currentUser && currentUser.ultimoCambio
                            ? <div className="ultima-actualizacion col-12 pt-2 mr-5" align="right" style={{ color: "#B2B2B2" }}><em> &Uacute;ltima actualizaci&oacute;n: {currentUser.ultimoCambio.toLocaleString('es-EC', { 'year': 'numeric', 'month': '2-digit', 'day': '2-digit'}) }</em></div>
                            : ''}
                            </div>*/
                        }
                        <div className="parent_contenido_pantalla">
                            <div className="btn_mostrar_barra" onClick={() => this.setState({ openSideBar: !this.state.openSideBar })}> <i className="fas fa-solid fa-bars" ></i> </div>

                            <Transition
                                in={this.state.openSideBar && currentUser !== null && currentUser.idpersona !== 0}
                                timeout={400}
                                unmountOnExit
                                mountOnEnter

                            >
                                {state => (

                                    <Sidebar_Principal onClickOverlay={() => this.setState({ openSideBar: false })} />
                                )}
                            </Transition>
                            {/* {currentUser !== null && currentUser.idpersona !== 0 ? <Sidebar_Principal /> : ""} */}
                            <div className="main-panel" id="main-panel" ref={this.mainPanel}>
                                <Alert />
                                <Switch>
                                    <Route
                                        path="admin/dashboard"
                                        component={Dashboard_Admin}
                                        key="dashboard"
                                    />
                                    {routes.map((prop, key) => {
                                        return (
                                            <Route
                                                path={prop.layout + prop.path}
                                                component={prop.component}
                                                key={key}
                                            />

                                        );
                                    })}


                                    {
                                        ADMINISTRADOR_ROUTES.map((rutas, key) => {
                                            return (
                                                <Route
                                                    path={rutas.layout + rutas.path}
                                                    component={rutas.component}
                                                    key={key}
                                                />
                                            );
                                        })

                                    }

                                    <Route
                                        path={"/admin/emisionCertificados"}
                                        render={(props) => <SolicitudesCertificados urlConsulta={`SolicitudCertificados/Analista/SolicitudesPendientes`} />}
                                    />
                                    <Route
                                        exact path={"/admin/historialEmisionCertificados"}
                                        render={(props) => <SolicitudesCertificados urlConsulta={`SolicitudCertificados/Analista/HistorialSolicitudesCertificados`} />}
                                    />

                                    <Route
                                        path="admin/datos-generales"
                                        component={DatosGenerales}
                                        key="datos-generales"
                                    />






                                </Switch>
                                {/*{*/}
                                {/*    <ModalActualizarDatosPers*/}
                                {/*        show={this.state.currentUser !== null && this.state.currentUser.ultimoCambio && this.state.currentUser.token && this.state.currentUser.showModalActualizarDP && this.state.showModalCambios}*/}
                                {/*        fechaActualizacion={this.state.currentUser.ultimoCambioDatosPersonales}*/}
                                {/*        tokenUser={this.state.currentUser.token}*/}
                                {/*        onClose={() => this.setState({ showModalCambios: false })}*/}

                                {/*    />*/}
                                

                                {
                                    
                                    <ModalTiempoSesion
                                        show={this.state.showModalSession}
                                        tokenUser={authenticationService.currentUserValue.token}
                                        onClose={() => { this.setState({ showModalSession: false }) }}
                                    />
                                }

                            </div>
                        </div>

                        <Footer fluid />

                    </div>
                }
            </div>
        );
    }
}

export default Dashboard;
